import moment from "moment";

export default {
  // 日期时间格式化
  formatTime(value, format) {
    return moment(value * 1000).format(format);
  },

  //图片缩略图
  thumbImage(value, width, height) {
    return (
      value +
      `?imageView2/2${width ? "/w/" + width : ""}${
        height ? "/h/" + height : ""
      }`
    );
  },

  //视频缩略图
  thumbVideo(value, width, height, offset = 1) {
    return value + `?vframe/png/offset/${offset}/w/${width}/h/${height}`;
  }
};
